import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToasterService } from './toaster.service';
import { Router } from '@angular/router';
import { Observable, catchError, forkJoin, map, of, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';


interface UsersResponse {
  pager: { total: number };
  items: User[];
}

interface User {
  id: number;
  name: string;
  email: string;
}
@Injectable({
  providedIn: 'root'
})
export class UserService {
  LocationID: any;

  constructor(private http: HttpClient, public router: Router, private toaster: ToasterService) { }

  getAllUsers(pageSize: number, currentPage: number, searchQuery: string = '', email: string = '.com'): Observable<UsersResponse> {
    const url = `${environment.host}/user?page=${currentPage}&q=${searchQuery}&email=${email}&perpage=${pageSize}`;
    return this.http.get<UsersResponse>(url);
  }

  fetchUsers(email: string = ''): Observable<any> {
    const url = `${environment.host}/usersearch?email=${email}`;
    return this.http.get<UsersResponse>(url);
  }
  

  private getTotalItemsforQuery(searchQuery: string, email: string): Observable<number> {
    const url = `${environment.host}/user?page=1&q=${searchQuery}&email=${email}`;
    return this.http.get<any>(url).pipe(
      map(response => response.pager.total),
      catchError(error => {
        console.error('Error fetching total items:', error);
        return of(0);
      })
    );
  }

getLocations(userId: string): Observable<any>  {
  let api = `${environment.host}/${environment.user}/${userId}/${environment.location}`;
  return this.http.get(api).pipe(
    map((res) => {
      return res || {};
    }) );
  }

  getDevices(userId: string): Observable<any>  {
    let api = `${environment.host}/${environment.user}/${userId}/${environment.device}`;
    return this.http.get(api).pipe(
      map((res) => {
        return res || {};
      }) );
    }

  getSubscriptionsHistory(userId: String): Observable<any> {
    let api = `${environment.host}/${environment.user}/${userId}/${environment.subscriptions}/${environment.history}`;
    return this.http.get(api).pipe(
      map((res) => {
        return res || {};
      }),
    );
  }

  deferSubscription(userId: String, payload: any): Observable<any> {
    let api = `${environment.host}/${environment.user}/${userId}/${environment.subscriptions}/${environment.defer}`;
    return this.http.post(api, payload);
  }
  
    getevent(LocationID: string, page: number = 1): Observable<any>{
      let api = `${environment.host}/location/${LocationID}/event?page=${page}`;
      return this.http.get(api).pipe(
        map((res)=>{
          return res || {};
        })  );
    }
    
    getMembersByPage(locationID: string, pageNumber: number): Observable<any> {
      const apiUrl = `${environment.host}/location/${locationID}/member?page=${pageNumber}`;
  
      return this.http.get(apiUrl).pipe(
        map((res) => {
          return res || {};
        })
      );
    }

    getAllMembers(locationID: string): Observable<any> {
      const apiUrl = `${environment.host}/location/${locationID}/member`;
  
      return this.http.get(apiUrl).pipe(
        map((res) => {
          return res || {};
        })
      );
    }

    getLocationData(locationId: string): Observable<any> {
      if (!locationId) {
        console.error('No location ID provided.');
        // Return an observable with an error or a default value as needed
        return new Observable(); // Update this part based on your needs
      }
  
      const apiUrl = `${environment.host}/location/${locationId}`;
  
      return this.http.get(apiUrl).pipe(
        map((res) => {
          return res || {};
        })
      );
    }

    getUserData<T>(page: number, searchQuery: string): Observable<T> {
      const bearerToken = 'db709c3fbbe65f0fd436a74a38843b87088817d52e598e379aa2128734963324';
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${bearerToken}`,
        'content-type': 'application/json;charset=utf-8'
      });
      const url = `${environment.host}/user?page=${page}&q=${searchQuery}`;
    
      return this.http.get<T>(url, { headers });
    }

    getOTAJobs(): any {
      const apiUrl = `${environment.host}/listotajobs`;
      return this.http.get(apiUrl);
    }

    fetchOTAData(OTAID: string): any {
      const apiUrl = `${environment.host}/ota-job/${OTAID}`;
      return this.http.get(apiUrl);
    }
    
    postOTA(file: File): Observable<any> {
      const apiUrl = `${environment.host}/createotajob`;
      const formData = new FormData();
      formData.append('fileData', file);
      formData.append('filename', file.name);
  
      return this.http.post(apiUrl, formData);
    }   

    createOTAJob(formData: FormData): Observable<any> {
      return this.http.post(`${environment.host}/createotajob`, formData);
    }
    
    searchUserByID(userID: string): Observable<any> {
      const endpoint = `${environment.host}/usersearch/${userID}`;
      return this.http.get(endpoint);
    }

    getUserDataByUserID(userID: string): Observable<any> {
      const apiUrl = `${environment.host}/user/${userID}`;
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      };
  
      return this.http.get(apiUrl, httpOptions);
    }
  
}
